/**
 * UX-only JWT helpers — never session authority (V2 identity cookie-only).
 * Proactive refresh timer reads `exp` when a non-HttpOnly copy exists in tests;
 * production HttpOnly access uses config interval fallback only.
 */

function decodeJwtPayloadPart(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length < 2 || parts[1] === undefined) {
    return null;
  }
  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const json = atob(padded);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Returns access JWT `exp` in ms, or null when unavailable / invalid. */
export function parseAccessTokenExpMs(accessToken: string | null | undefined): number | null {
  if (accessToken === null || accessToken === undefined || accessToken.trim().length === 0) {
    return null;
  }
  const payload = decodeJwtPayloadPart(accessToken.trim());
  const exp = payload?.exp;
  if (typeof exp !== 'number' || !Number.isFinite(exp)) {
    return null;
  }
  return exp * 1000;
}
